export default __webpack_public_path__ + "static/100StartupsToWatch-5f577cad3a9d4840ef12d06175c3aebf.png";